export { computeStops } from "../shared/colors.ts";

/** Areas without a value: a light grey, so a blank never reads as a value or as "not on the map" (legend: No data). */
export const NO_DATA_FILL = "rgba(148, 163, 184, 0.32)";

/** MapLibre expression: smooth color from feature-state `v`; NO_DATA_FILL when the area has no value. */
export function fillExpression(colors: string[], stops: number[]): unknown {
  if (!colors.length || stops.length !== colors.length) return "rgba(0,0,0,0)";
  const interp: unknown[] = ["interpolate", ["linear"], ["to-number", ["feature-state", "v"]]];
  stops.forEach((s, i) => interp.push(s, colors[i]));
  return ["case", ["==", ["typeof", ["feature-state", "v"]], "number"], interp, NO_DATA_FILL];
}

/** CSS gradient for the legend bar. */
export function cssGradient(colors: string[]): string {
  return `linear-gradient(to right, ${colors.join(", ")})`;
}
